"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactSwitch = _interopRequireDefault(require("react-switch"));
var _lodash = require("lodash");
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
var _pages = require("chaire-lib-frontend/lib/components/pages");
var _LodashExtensions = require("chaire-lib-common/lib/utils/LodashExtensions");
var _utils = require("../../../services/ui/utils");
var _InputMultiselect = _interopRequireDefault(require("chaire-lib-frontend/lib/components/input/InputMultiselect"));
var _InputString = _interopRequireDefault(require("chaire-lib-frontend/lib/components/input/InputString"));
var _OctaviParameters = _interopRequireDefault(require("../../../services/ui/OctaviParameters"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // import Button from 'transition-frontend/src/components/input/Button'
class TemporalFilterPanel extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterSelected: _OctaviParameters.default.get('filterSelected', "FilterOne"),
      filters: _OctaviParameters.default.filters,
      dataSourceIds: _OctaviParameters.default.dataSourceIds
    };
    this.hourChoices = [{
      value: "0_6"
    }, {
      value: "6_9"
    }, {
      value: "9_15"
    }, {
      value: "15_18"
    }, {
      value: "18_24"
    }, {
      value: "other"
    }];
    this.dayChoices = [{
      value: "monday"
    }, {
      value: "tuesday"
    }, {
      value: "wednesday"
    }, {
      value: "thursday"
    }, {
      value: "friday"
    }, {
      value: "saturday"
    }, {
      value: "sunday"
    }, {
      value: "business_day"
    }, {
      value: "non_working_day"
    }, {
      value: "weekend"
    }];
    this.updateFilter = this.updateFilter.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onSwitchChange = this.onSwitchChange.bind(this);
    this.updateDataSourceIds = this.updateDataSourceIds.bind(this);
    this.updateFilterSelection = this.updateFilterSelection.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    ;
    this.onCustomHourChange = this.onCustomHourChange.bind(this);
    this.onCustomHourDeleteButtonClick = this.onCustomHourDeleteButtonClick.bind(this);
    this.onCustomHourAddButtonClick = this.onCustomHourAddButtonClick.bind(this);
  }
  componentDidMount() {
    _ServiceLocator.default.eventManager.on('taxi.dataSources.loaded', this.updateDataSourceIds);
    _ServiceLocator.default.eventManager.on('taxi.filter.filterSelection.update', this.updateFilterSelection);
    _ServiceLocator.default.eventManager.on('taxi.filter.init', this.updateFilter);
    _ServiceLocator.default.eventManager.on('taxi.filter.data.update', this.updateFilter);
  }
  componentWillUnmount() {
    _ServiceLocator.default.eventManager.off('taxi.dataSources.loaded', this.updateDataSourceIds);
    _ServiceLocator.default.eventManager.off('taxi.filter.filterSelection.update', this.updateFilterSelection);
    _ServiceLocator.default.eventManager.off('taxi.filter.init', this.updateFilter);
    _ServiceLocator.default.eventManager.off('taxi.filter.data.update', this.updateFilter);
  }
  updateDataSourceIds() {
    this.setState({
      dataSourceIds: _OctaviParameters.default.dataSourceIds
    });
  }
  updateFilterSelection() {
    this.setState({
      filterSelected: _OctaviParameters.default.filterSelected
    });
  }
  updateFilter() {
    this.setState({
      filters: _OctaviParameters.default.filters
    });
  }
  onButtonClick(name) {
    // name is name of the clicked button must be "hourIsSelected", "dayIsSelected"
    const newFilters = (0, _lodash.cloneDeep)(this.state.filters);
    const filterIdx = (0, _utils.getFilterIdx)(this.state.filters, this.state.filterSelected);
    const generalSwitchState = this.state.filters[filterIdx].temporalFilterIsSelected;

    // if switch is on off we set switch to on and only set clicked button to on
    if (!generalSwitchState) {
      newFilters[filterIdx]['hourIsSelected'] = name == "hourIsSelected" ? true : false;
      newFilters[filterIdx]['dayIsSelected'] = name == "dayIsSelected" ? true : false;
      newFilters[filterIdx]['temporalFilterIsSelected'] = true;
    } else {
      // by default we change button  state
      if (name === 'hourIsSelected') {
        newFilters[filterIdx]['hourIsSelected'] = !newFilters[filterIdx]['hourIsSelected'];
      } else if (name === 'dayIsSelected') {
        newFilters[filterIdx]['dayIsSelected'] = !newFilters[filterIdx]['dayIsSelected'];
      }

      // if all filters are on off we also set switch to off
      if (!newFilters[filterIdx]['hourIsSelected'] && !newFilters[filterIdx]['dayIsSelected']) {
        newFilters[filterIdx]['temporalFilterIsSelected'] = false;
      }
    }
    //update filter values
    this.setState({
      filters: newFilters
    });
    _OctaviParameters.default.filters = newFilters;
    _ServiceLocator.default.eventManager.emit('taxi.filter.data.update');
  }
  onSwitchChange() {
    const newFilters = (0, _lodash.cloneDeep)(this.state.filters);
    const filterIdx = (0, _utils.getFilterIdx)(this.state.filters, this.state.filterSelected);
    const previousGeneralSwitchState = this.state.filters[filterIdx].temporalFilterIsSelected;
    newFilters[filterIdx]['temporalFilterIsSelected'] = !previousGeneralSwitchState;

    //if we set switch to one, we make sure to have a list one filter to one
    if (newFilters[filterIdx]['temporalFilterIsSelected']) {
      // if no filter
      if (!newFilters[filterIdx]['dayIsSelected'] && !newFilters[filterIdx]['hourIsSelected']) {
        newFilters[filterIdx]['dayIsSelected'] = true;
        newFilters[filterIdx]['hourIsSelected'] = false;
      }
    }
    //update filter values
    this.setState({
      filters: newFilters
    });
    _OctaviParameters.default.filters = newFilters;
    _ServiceLocator.default.eventManager.emit('taxi.filter.data.update');
  }
  onValueChange(selectedObjectName, value, pairedButtonName) {
    const newFilters = (0, _lodash.cloneDeep)(this.state.filters);
    const filterIdx = (0, _utils.getFilterIdx)(this.state.filters, this.state.filterSelected);
    let needToUpatePairedButton = false;
    // if unselecting all values set filter to off
    if ((0, _lodash.isNull)(value) || value.length == 0) {
      if (this.state.filters[filterIdx][pairedButtonName]) {
        needToUpatePairedButton = true;
      }
    }
    //compare with old state to see if adding or deleting
    else if (value.length !== ((0, _LodashExtensions._isBlank)(this.state.filters[filterIdx][selectedObjectName]) ? 0 : this.state.filters[filterIdx][selectedObjectName].length)) {
      //if filter is not selected and we add a value --> we select the filter$
      if (!this.state.filters[filterIdx][pairedButtonName] || !this.state.filters[filterIdx][`temporalFilterIsSelected`]) {
        needToUpatePairedButton = true;
      }
    }

    // order the value list from choice list order
    if (value) {
      const choices = selectedObjectName.includes('hour') ? this.hourChoices : this.dayChoices;
      const choicesValues = choices.map(x => x.value);
      const idxs = value.map(x => choicesValues.indexOf(x)).sort();
      value = idxs.map(x => choicesValues[x]);
    } else {
      value = [];
    }
    newFilters[filterIdx][selectedObjectName] = value;

    //add or delete custom value when selecting or unslecting other in hour filter
    if (selectedObjectName.includes('hour') && value.includes('other')) {
      //case when selecting other --> we inti custom filters
      if (value.includes('other') && ((0, _LodashExtensions._isBlank)(this.state.filters[filterIdx][selectedObjectName]) || !this.state.filters[filterIdx][selectedObjectName].includes('other'))) {
        newFilters[filterIdx][`hourCustomChoices`] = ["0_24"];
      }
      // case when deleting options
      else if (!value.includes('other') && !(0, _LodashExtensions._isBlank)(this.state.filters[filterIdx][selectedObjectName]) && this.state.filters[filterIdx][selectedObjectName].includes('other')) {
        newFilters[filterIdx][`hourCustomChoices`] = null;
      }
    }
    this.setState({
      filters: newFilters
    }, function () {
      if (needToUpatePairedButton) {
        this.onButtonClick(pairedButtonName);
      }
    });
    _OctaviParameters.default.filters = newFilters;
    _ServiceLocator.default.eventManager.emit('taxi.filter.data.update');
  }
  onCustomHourChange(e, hourType, idx) {
    const newFilters = (0, _lodash.cloneDeep)(this.state.filters);
    const filterIdx = (0, _utils.getFilterIdx)(this.state.filters, this.state.filterSelected);
    const newCustomHour = newFilters[filterIdx][`hourCustomChoices`];
    const oldValue = newCustomHour[idx];
    if (hourType === "start") {
      //verification of hour validity
      if (0 <= e.target.value && e.target.value <= Math.min(parseInt(oldValue.split("_")[1]), 24)) {
        newCustomHour[idx] = `${e.target.value}_${oldValue.split("_")[1]}`;
      }
    } else if (hourType === "end") {
      if (Math.max(parseInt(oldValue.split("_")[0]), 0) <= e.target.value && e.target.value <= 24) {
        newCustomHour[idx] = `${oldValue.split("_")[0]}_${e.target.value}`;
      }
    }
    newFilters[filterIdx][`hourCustomChoices`] = newCustomHour;
    this.setState({
      filters: newFilters
    });
    _OctaviParameters.default.filters = newFilters;
    _ServiceLocator.default.eventManager.emit('taxi.filter.data.update');
  }
  onCustomHourDeleteButtonClick(idx) {
    const newFilters = (0, _lodash.cloneDeep)(this.state.filters);
    const filterIdx = (0, _utils.getFilterIdx)(this.state.filters, this.state.filterSelected);
    const newCustomHour = newFilters[filterIdx][`hourCustomChoices`];
    newCustomHour.splice(idx, 1);
    newFilters[filterIdx][`hourCustomChoices`] = newCustomHour;
    this.setState({
      filters: newFilters
    });
    _OctaviParameters.default.filters = newFilters;
    _ServiceLocator.default.eventManager.emit('taxi.filter.data.update');
  }
  onCustomHourAddButtonClick() {
    const newFilters = (0, _lodash.cloneDeep)(this.state.filters);
    const filterIdx = (0, _utils.getFilterIdx)(this.state.filters, this.state.filterSelected);
    const newCustomHour = !(0, _lodash.isNull)(newFilters[filterIdx][`hourCustomChoices`]) ? newFilters[filterIdx][`hourCustomChoices`] : [];
    newCustomHour.push("0_24");
    newFilters[filterIdx][`hourCustomChoices`] = newCustomHour;
    this.setState({
      filters: newFilters
    });
    _OctaviParameters.default.filters = newFilters;
    _ServiceLocator.default.eventManager.emit('taxi.filter.data.update');
  }
  render() {
    //temporal filters component construction
    const temporalFiltersInput = [];
    const filterIdx = (0, _utils.getFilterIdx)(this.state.filters, this.state.filterSelected);
    if (this.state.filters.length !== 0) {
      // hour filter construction
      temporalFiltersInput.push(/*#__PURE__*/_react.default.createElement("div", {
        className: "oct_filter_section _space-between-columns",
        key: "temporalFilterHour"
      }, /*#__PURE__*/_react.default.createElement("button", {
        id: `formFieldTaxiActivitiesSelectTemporalFilterHour`,
        className: this.state.filters[filterIdx][`hourIsSelected`] && this.state.filters[filterIdx][`temporalFilterIsSelected`] ? "button green _three_columns" : "button grey _three_columns",
        type: "button",
        onClick: x => this.onButtonClick(`hourIsSelected`)
      }, this.props.t('octavi:filters:temporal:hour')), /*#__PURE__*/_react.default.createElement("div", {
        className: "_two_third_column"
      }, /*#__PURE__*/_react.default.createElement(_InputMultiselect.default, {
        style: {
          display: "inline-block"
        },
        choices: this.hourChoices,
        localePrefix: 'octavi:filters:temporal:hour_',
        t: this.props.t,
        disabled: false,
        id: `formFieldTaxiActivitiesSelectTemporalFilterHourChoices`,
        value: this.state.filters[filterIdx][`hourChoices`] ? this.state.filters[filterIdx][`hourChoices`] : [],
        onValueChange: e => this.onValueChange(`hourChoices`, e.target.value, `hourIsSelected`),
        customStyles: this.state.filters[filterIdx][`hourIsSelected`] && this.state.filters[filterIdx][`temporalFilterIsSelected`] ? {
          multiValue: (base, _state) => _objectSpread(_objectSpread({}, base), {}, {
            backgroundColor: 'rgba(70, 128, 36,0.5)'
          })
        } : null
      }))));

      //custom hour filter
      if ((this.state.filters[filterIdx][`hourChoices`] ? this.state.filters[filterIdx][`hourChoices`] : []).includes('other')) {
        for (let idx in this.state.filters[filterIdx][`hourCustomChoices`]) {
          const customFilter = this.state.filters[filterIdx][`hourCustomChoices`][idx];
          temporalFiltersInput.push(/*#__PURE__*/_react.default.createElement("div", {
            className: "oct_filter_section _space-between-columns",
            key: `temporalCustomFilterHour_${idx}`
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: " _three_columns"
          }, `${this.props.t('octavi:filters:temporal:customHours:name')} ${parseInt(idx) + 1}`), /*#__PURE__*/_react.default.createElement("div", {
            className: "_two_third_column same_line"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "_three_columns"
          }, /*#__PURE__*/_react.default.createElement(_InputString.default, {
            value: customFilter.split("_")[0],
            type: 'number',
            onValueChange: e => this.onCustomHourChange(e, "start", idx)
          })), /*#__PURE__*/_react.default.createElement("div", {
            className: "center"
          }, this.props.t("main:rangeTo")), /*#__PURE__*/_react.default.createElement("div", {
            className: "_three_columns"
          }, /*#__PURE__*/_react.default.createElement(_InputString.default, {
            value: customFilter.split("_")[1],
            type: 'number',
            onValueChange: e => this.onCustomHourChange(e, "end", idx)
          })), /*#__PURE__*/_react.default.createElement("button", {
            type: "button",
            className: "option_delete_button",
            onClick: () => this.onCustomHourDeleteButtonClick(idx),
            disabled: this.state.filters[filterIdx][`hourCustomChoices`].length <= 1
          }, /*#__PURE__*/_react.default.createElement("img", {
            src: "/dist/images/icons/octavi/close_white.svg",
            alt: "delete",
            style: {
              width: "90%"
            }
          })))));
        }
        temporalFiltersInput.push(/*#__PURE__*/_react.default.createElement("button", {
          className: "_two_third_column _input _input-select-button _bottom_padding",
          key: "addCustomFilter",
          style: {
            display: "inline-block"
          },
          type: "button",
          onClick: this.onCustomHourAddButtonClick
        }, this.props.t('octavi:filters:temporal:customHours:addButton')));
      }

      //day filter construction
      temporalFiltersInput.push(/*#__PURE__*/_react.default.createElement("div", {
        className: "oct_filter_section _space-between-columns",
        key: "temporalFilterDay"
      }, /*#__PURE__*/_react.default.createElement("button", {
        id: `formFieldTaxiActivitiesSelectTemporalFilterDay`,
        className: this.state.filters[filterIdx][`dayIsSelected`] && this.state.filters[filterIdx][`temporalFilterIsSelected`] ? "button green _three_columns" : "button grey _three_columns",
        type: "button",
        onClick: x => this.onButtonClick(`dayIsSelected`)
      }, this.props.t('octavi:filters:temporal:day')), /*#__PURE__*/_react.default.createElement("div", {
        className: "_two_third_column"
      }, /*#__PURE__*/_react.default.createElement(_InputMultiselect.default, {
        style: {
          display: "inline-block"
        },
        choices: this.dayChoices,
        localePrefix: 'octavi:filters:temporal:day_',
        t: this.props.t,
        disabled: false,
        id: `formFieldTaxiActivitiesSelectTemporalFilterDayChoices`,
        value: this.state.filters[filterIdx][`dayChoices`] ? this.state.filters[filterIdx][`dayChoices`] : [],
        onValueChange: e => this.onValueChange(`dayChoices`, e.target.value, `dayIsSelected`),
        customStyles: this.state.filters[filterIdx][`dayIsSelected`] && this.state.filters[filterIdx][`temporalFilterIsSelected`] ? {
          multiValue: (base, _state) => _objectSpread(_objectSpread({}, base), {}, {
            backgroundColor: 'rgba(70, 128, 36,0.5)'
          })
        } : null
      }))));
    }
    if (this.state.dataSourceIds.length === 0 || this.state.filters.length === 0) {
      return /*#__PURE__*/_react.default.createElement(_pages.LoadingPage, null);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "tr__form-input-container _margin_bottom_small"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_margin_bottom_small _bottom_border"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_filter_section _space-between-columns _margin_bottom_small"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "_left"
    }, this.props.t('octavi:filters:temporal:sectionName')), /*#__PURE__*/_react.default.createElement(_reactSwitch.default, {
      id: `formFieldTaxiActivitiesSelectTemporalFilter`,
      onChange: this.onSwitchChange,
      checked: this.state.filters[filterIdx][`temporalFilterIsSelected`],
      onColor: "#609112",
      height: 25
    }))), temporalFiltersInput);
  }
}
var _default = exports.default = (0, _reactI18next.withTranslation)()(TemporalFilterPanel);